import React, { FC, useEffect, useState } from "react";

import { navigate } from "gatsby";
import { CalculatorTemplate } from "../../../../templates/CalculatorTemplate";
import LoanToValueForm from "./forms/LoanToValueForm";
import { trackEvent } from "../../../../helpers/analytics";
import { LoanToValueCalculatorResults } from "./LoanToValueCalculatorResults";
import { convertCurrencyStringToFloat } from "../calculatorMethods";
import { calculateResults } from "./calculateResults";
import "./styles.scss";

export interface ILoanToValueCalculatorPanelProps {
    id: string;
    title: string;
    ctaText: string;
    ctaUrl: string;
    footerHeading?: string;
    footerText?: string;
}

export const LoanToValueCalculatorPanel: FC<ILoanToValueCalculatorPanelProps> = ({
  id,
  title,
  ctaText,
  ctaUrl,
  footerHeading,
  footerText,
}) => {
  const [valueType, setValueType] = useState("DEPOSIT_AMOUNT");
  const [propertyValue, setPropertyValue] = useState("");
  const [knownValue, setKnownValue] = useState("");
  const [shouldAnimate, setShouldAnimate] = useState(true);

  const handleAnimation = () => {
    setShouldAnimate(false);
  };

  useEffect(() => {
    setKnownValue("");
    setShouldAnimate(true);
  }, [valueType]);

  const updateResults = () => {
    if (knownValue === "" || propertyValue === "") return ["", ""];
    return calculateResults(convertedPropertyValue, convertedKnownValue, valueType);
  };
  const convertedPropertyValue = convertCurrencyStringToFloat(propertyValue);
  const convertedKnownValue = convertCurrencyStringToFloat(knownValue);

  const results = updateResults();

  return (
    <>
      <CalculatorTemplate
        title={title}
        description=""
        tabInformation={[
          {
            title: "Loan to value calculator results",
            form: (
              <LoanToValueForm
                valueType={valueType}
                setValueType={setValueType}
                propertyValue={propertyValue}
                setPropertyValue={setPropertyValue}
                knownValue={knownValue}
                setKnownValue={setKnownValue}
                handleAnimation={handleAnimation}
              />
            ),
            calculatorResults: {
              top: {
                result: "",
              },
              TopResultComponent: () => (
                <LoanToValueCalculatorResults
                  resultType={valueType}
                  shouldAnimate={shouldAnimate}
                  results={results}
                />
              ),
              middle: {},
              bottom: {},
              cta: {
                title: ctaText,
                url: ctaUrl,
                handleClick: (e) => {
                  e.preventDefault();
                  trackEvent("CTA Clicked", {
                    module: "Loan To Value Calculator",
                  });
                  navigate(ctaUrl);
                },
              },
              footer: {
                heading: footerHeading || "Next steps",
                text: footerText || "Answer a few more questions. Then a Better.co.uk adviser will find our best mortgage deal for you.",
              },
            },
          },
        ]}
        id={id}
        disclaimer=""
        defaultTab={0}
      />
    </>
  );
};
